<template>
  <div v-if="schema">
    <div 
      v-if="schema.message" 
      v-html="schema.message" 
      class="vf-form-message">
    </div>

    <validation-error
      v-if="invalidFields" 
      :invalid-fields="invalidFields"
      @goto="gotoField">
    </validation-error>

    <form 
      v-if="schema.groups" 
      @submit.prevent="submit">
      <field-group 
        v-for="(group, index) in schema.groups" 
        :group="group" 
        :is-last="(index + 1 == schema.groups.length)"
        :key="group.id"
        :ref="'group-' + group.id">
      </field-group>
      <div class="grid-x grid-padding-x" style="margin-top: 1rem">
        <div class="cell small-12 medium-text-right">
          <div class="vf-actions">
            <button class="btn btn-primary btn-large btn-expanded-small no-margin" type="submit">
              {{ status.busy ? 'Sending...' : submitLabel }}
            </button>
          </div>
        </div>
      </div>
      <input v-model="hp" type="text" class="hide" name="hp">
    </form>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import FieldGroup from '@/FieldGroup.vue'
import ValidationError from '@/ValidationError.vue'
const VueScrollTo = require('vue-scrollto')

export default { 
  name: 'Form',
  components: {
    FieldGroup, ValidationError
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hp: ''
    }
  },
  methods: {
    gotoField (id) {
      let el = document.getElementById('field-' + id)
      this.$nextTick(() => {
        VueScrollTo.scrollTo(el, 100, { offset: -10 })
      })
    },
    submit () {
      if (!this.status.busy && this.hp == '') {

        this.$commit.setInvalidFields([])

        let res = this.validate()
        console.log('validation result', res)

        if (this.validate()) {
          this.$dispatch.submit()
          .then(function(response) {
            if (response.data.success) {
              this.$commit.setStatus({ key: 'message', value: response.data.message })
              this.$commit.setStatus({ key: 'complete', value: true })
              this.$commit.reset(true)
            } else {
              switch (response.data.error) {
                case 'validation_error':
                  if ('invalid_fields' in response.data) {
                    this.$commit.setInvalidFields(response.data.invalid_fields)
                  }
                  break
                case 'generic_error':
                  this.$commit.setStatus({ key: 'error', value: 'An error has occurred, your form could not be submitted.' })
                  break
              }
            }
          }.bind(this))
          .catch(function (error) {
            this.$commit.setStatus({ key: 'error', value: error })
          }.bind(this))
          .finally(function() {
            this.$commit.setStatus({ key: 'busy', value: false })
          }.bind(this))
        } else {
          console.log('scroll to top of form')
          let el = this.$root.$el
          this.$nextTick(() => {
            VueScrollTo.scrollTo(el, 100, { offset: -20 })
          })
        }
      }
    },
    validate () {
      const self = this
      let is_valid = true
      _.each(this.schema.groups, function(group) {
        let obj = self.$refs['group-' + group.id][0]
        if (group.conditional == 0 || (group.conditional == 1 && obj.showGroup)) {
          let result = obj.validate()
          if (result === false) {
            is_valid = false
          }
        }
      })
      return is_valid
    }
  },
  computed: {
    status () {
      return this.$store.status
    },
    invalidFields () {
      let invalid_fields = this.$store.invalidFields
      return (invalid_fields.length ? invalid_fields : false)
    },
    schema () {
      return this.options.schema
    },
    submitLabel () {
      let label = this.options.submit_label
      return (label != '' ? label : 'Submit') 
    },
    error () {
      return this.status.error
    }
  }
}
</script>
